module.exports = __webpack_public_path__ + "img/image (21).1343390d.png";